import React, { useState } from "react";
import "./style.scss";
import AuthFrame from "../../../components/Auth/AuthFrame";
import SigninForm from "../../../components/Auth/SigninForm";
import ForgotPasswordForm from "../../../components/Auth/ForgotPasswordForm";

const ForgotPassword = () => {
  const [errorModalOpen, setErrorModalOpen] = useState(false);

  return (
    <div className="signin-container">
      {/* <ErrorModal/> */}
      <div className="signin-left-wrapper">
        <div className="signin-left-form">
          <ForgotPasswordForm />
        </div>
      </div>
      <div className="signin-right-wrapper">
        <div className="signin-right-authframe">
          <AuthFrame />
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
